module.exports = __webpack_public_path__ + "img/CRC1_Mono.Macro.ccc849c2.png";